import React, { Component } from "react";

import { defined } from "@formant/core/common/defined";
import { ISchedule } from "@formant/core/model/ISchedule";

import { appStore, scheduleStore } from "../../../stores";
import { Buttons } from "../../common/Buttons";
import { ActionButton } from "../ActionButton";

export interface IActionsProps {
    schedule: ISchedule;
}

export class Actions extends Component<IActionsProps> {
    public render() {
        return (
            <Buttons>
                <ActionButton icon="delete" onClicked={this.onDelete} />
            </Buttons>
        );
    }

    private onDelete = () => {
        const { schedule } = this.props;
        appStore.setConfirm({
            title: "Delete schedule",
            message: `Delete schedule "${schedule.name}"?`,
            onOk: async () => {
                try {
                    await scheduleStore.delete(defined(schedule.id));
                } catch (error) {
                    appStore.setSnackbar(
                        "Failed to delete schedule. Schedules with users cannot be deleted",
                    );
                    return;
                }
                appStore.setSnackbar("Schedule deleted");
            },
        });
    };
}
